import { CashRegisterMoneyModelAdd, CashRegisterMoneyModelType } from '@teinor/erp/types/company/cashRegister/cashRegisterMoney'
import { useCallback } from 'react'
import CustomError from '../../../../../../../baseComponents/CustomError'
import LoadingSpinner from '../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import TableWithoutVirtualListing from '../../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import { CustomRenderString } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { RectangularInputPrice } from '../../../../../../../forms/Input/InputPrice'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveCurrencies } from '../../../../../../../utils/reducers/getters'
import { PaymentTypesRegisterMoneyTPV } from '../../types'


interface CashRegisterMoneyTableProps extends CashRegisterMoneyTableLogicProps {
    cashRegisterMoneyRows: CashRegisterMoneyModelAdd[]
    isCloseCashRegister: boolean
    isReadOnly?: boolean
}

const CashRegisterMoneyTable: React.FC<CashRegisterMoneyTableProps> = ({ cashRegisterMoneyRows, setPaymentTypesRegisterMoney, isCloseCashRegister, isReadOnly }) => {
    const { t } = useTwinTranslation()
    const { handleChangeField } = useCashRegisterMoneyTableLogic({ setPaymentTypesRegisterMoney })
    if (!cashRegisterMoneyRows) {
        return <LoadingSpinner />
    }
    const currencies = getActiveCurrencies()
    let extraColumn: any[] = []
    if (isCloseCashRegister) {
        extraColumn.push({
            id: 'endMoney',
            dataKey: 'endMoney',
            label: t('finalAmount', 'Importe final'),
            customRender: (parameterValue: any, allRowData: any) => <RectangularInputPrice label={''} CurrencyId={allRowData.CurrencyId || ''} value={parameterValue === null ? allRowData?.money : parameterValue} onChange={(value) => handleChangeField(allRowData.rowIndex, 'endMoney', value)} defaultValue={allRowData?.money} />,
        },)
    }
    const columnsCashRegisterMoney: ColumnTableSchema<CashRegisterMoneyModelType> = [
        {
            id: 'PaymentTypeId',
            dataKey: 'PaymentTypeId',
            label: t('paymentType', 'Tipo de pago'),
            customRender: (parameterValue, allRowData) => <CustomRenderString className='' value={allRowData?.PaymentType?.name || ''} />,
        },
        {
            id: 'CurrencyId',
            dataKey: 'CurrencyId',
            label: t('currency', 'Moneda'),
            customRender: (parameterValue, allRowData) => <CustomRenderString className='' value={currencies?.[allRowData?.PaymentType?.extraData?.CurrencyId]?.code || ''} />,
        },
        {
            id: 'money',
            dataKey: 'money',
            label: t('amount', 'Importe'),
            customRender: (parameterValue, allRowData) => <RectangularInputPrice label={''} CurrencyId={allRowData.CurrencyId || ''} value={parameterValue} onChange={(value) => handleChangeField(allRowData.rowIndex, 'money', value)} readOnly={isCloseCashRegister || isReadOnly} />,
        },
        ...extraColumn
    ]

    return (
        <div className='overflow-visible mt-20'>
            {cashRegisterMoneyRows?.length
                ? <TableWithoutVirtualListing data={cashRegisterMoneyRows} columns={columnsCashRegisterMoney} disableScroll={true} />
                : <CustomError textError={t('dontHaveCashTpvPaymentTypes', 'No tienes tipos de pagos en metálico asociados al TPV')} className='mt-20' />}
        </div>
    )
}


interface CashRegisterMoneyTableLogicProps {
    setPaymentTypesRegisterMoney: React.Dispatch<React.SetStateAction<PaymentTypesRegisterMoneyTPV | null>>
}

const useCashRegisterMoneyTableLogic = ({ setPaymentTypesRegisterMoney }: CashRegisterMoneyTableLogicProps) => {
    const handleChangeField = useCallback((pos: number, field: string, value: any) => {
        setPaymentTypesRegisterMoney((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (copy) {
                copy.cashRegisterMoneyRows[pos][field] = value
            }
            return copy
        })
    }, [setPaymentTypesRegisterMoney])

    return { handleChangeField }
}

export default CashRegisterMoneyTable